export function pageSessionHeaders() {
  const page = document.querySelector('[data-page-session]')
  return page ? { "X-Page-Session": page.dataset.pageSession } : {}
}

export function refreshCsrf(token) {
  if (!token) return
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) meta.content = token
  document.querySelectorAll('input[name="authenticity_token"]').forEach(input => { input.value = token })
}

export function authenticationFailure(response, data, interactive = true) {
  const known = ["session_expired", "csrf_invalid", "account_changed", "authentication_required"]
  const reason = data && known.includes(data.error) ? data.error : (response.status === 401 || response.redirected ? "session_expired" : null)
  if (reason) document.dispatchEvent(new CustomEvent("session:invalid", { detail: { reason, interactive } }))
  return reason
}

// A read-only check does not renew the session or replay a failed write.
export async function prepareSession() {
  const page = document.querySelector('[data-page-session]')
  if (!page) return
  const abort = new AbortController()
  const timeout = setTimeout(() => abort.abort(), 10000)
  try {
    const response = await fetch(page.dataset.sessionActivityUrl, {
      method: "GET", credentials: "same-origin", cache: "no-store", redirect: "error",
      headers: { Accept: "application/json", ...pageSessionHeaders() }, signal: abort.signal
    })
    const data = await response.json().catch(() => null)
    if (authenticationFailure(response, data)) throw new Error("session_expired")
    if (!response.ok || !data) throw new Error("session_check_failed")
    refreshCsrf(data.csrf_token)
    document.dispatchEvent(new CustomEvent("session:checked", { detail: data }))
  } finally {
    clearTimeout(timeout)
  }
}
